if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);

      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });

      this.productWrapper = this.closest('.thb-product-detail');
      this.productSlider = this.productWrapper.querySelector('.product-images');
      this.hideVariants = this.dataset.hideVariants === 'true';
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
      this.bindNotifyMeButton();
    }

    onVariantChange() {
      
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();
      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.upDateVariantTemplate();
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }

        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }

      this.updateOther();
      this.toggleNotifyMeButton();
      
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });

      const swymCustomWishlistButton = document.querySelector(`.thb-product-detail .swymcs-wishlist-button-${this.dataset.productId}`);
      if (swymCustomWishlistButton) {
        swymCustomWishlistButton.setAttribute('data-epi', this.currentVariant.id);
      }
      window.swymcsWishlistFunctions.updateButtonState();

    
      const swatchElements = document.querySelectorAll('[swatch-data-color]');

      if (swatchElements.length > 0) {
        swatchElements.forEach(element => {
          const input = element.querySelector('input[checked]');
          if (input) {
            if (!this.currentVariant || !this.currentVariant.available) {
              element.classList.add('not-available');
            }else{
              element.classList.remove('not-available');
            }
          }
        });
      }
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
        }
      });
    }

    upDateVariantTemplate() {
      const currentVariantId = String(this.currentVariant.id);
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    
      if (!productForm) {
        console.warn(`Product form with ID product-form-${this.dataset.section} not found.`);
        return;
      }
    
      if (window.variantData && Array.isArray(window.variantData)) {
        const matchedVariant = window.variantData.find(variant => String(variant.id) === currentVariantId);
    
        if (matchedVariant) {
          const variantPreorder = String(matchedVariant.preorder);
    
          const productFormContainer = productForm.closest('.product-form');
          if (productFormContainer) {
            if (variantPreorder === 'true') {
              productFormContainer.setAttribute('template', 'pre-order');
            } else {
              productFormContainer.setAttribute('template', 'default');
            }
          } else {
            console.warn('Product form container not found.');
          }
        } else {
          console.warn(`No variant found matching ID: ${currentVariantId}`);
        }
      }
     
    }
    
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value='${option}']`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }

    updateMedia() {
      return;
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      let productSlider = document.querySelector('.thb-product-detail .product-images'),
        thumbnails = document.querySelector('.thb-product-detail #Product-Thumbnails');

      this.setActiveMedia(`#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, productSlider, thumbnails);
    }
    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      let flkty = Flickity.data(productSlider),
        activeMedia = productSlider.querySelector(mediaId);
      if (flkty && this.hideVariants) {
        if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
          productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
        }
        [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
          el.classList.remove('is-active');
        });

        activeMedia.classList.add('is-active');
        activeMedia.classList.add('is-initial-selected');

        this.setImageSetMedia();

        if (thumbnails) {
          let activeThumb = thumbnails.querySelector(thumbId);

          if (thumbnails.querySelector('.product-thumbnail.is-initial-selected')) {
            thumbnails.querySelector('.product-thumbnail.is-initial-selected').classList.remove('is-initial-selected');
          }
          [].forEach.call(thumbnails.querySelectorAll('.product-images__slide-item--variant'), function (el) {
            el.classList.remove('is-active');
          });

          activeThumb.classList.add('is-active');
          activeThumb.classList.add('is-initial-selected');
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.selectCell(mediaId);

      } else if (flkty) {
        productSlider.selectCell(mediaId);
      }

    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available && pickUpAvailability.fetchAvailability) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `inventory-size-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');

          });
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);

        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const productTemplate = productForm.closest('.product-form').getAttribute('template');

      // --- START FIX ---
      // 1. Get buttons ONLY inside this specific product form
      let submitButtons = Array.from(productForm.querySelectorAll('.single-add-to-cart-button'));

      // 2. Check for the Sticky ATC button (it usually lives outside the form)
      // We check if the sticky modal exists and grab its button
      const stickyModal = document.querySelector('.product-add-to-cart-sticky-modal');
      if (stickyModal) {
        const stickyBtn = stickyModal.querySelector('.single-add-to-cart-button');
        if (stickyBtn) {
          submitButtons.push(stickyBtn);
        }
      }
      // --- END FIX ---

      if (!submitButtons.length) return; // Safety check

      const sizeWrapperElement = document.querySelector(`.product-form-${this.dataset.section}-fielset-size`);

      if(sizeWrapperElement){
        if (!sizeWrapperElement.classList.contains('product-form__input-size')) {
          if(this.closest('.product-section')){
            this.closest('.product-section').classList.add('form-validation-valid');
          }
          sizeWrapperElement.classList.remove('product-form__input-size-validation-fail');
          submitButtons.forEach((submitButton) => {
            if (submitButton.classList.contains('loading')) return;
            submitButton.removeAttribute('aria-disabled');
            submitButton.disabled = false;
          });
        } else {
          if(this.closest('.product-section')){
            this.closest('.product-section').classList.remove('form-validation-valid');
          }
          sizeWrapperElement.classList.add('product-form__input-size-validation-fail');
          submitButtons.forEach((submitButton) => {
            if (submitButton.classList.contains('loading')) return;
            submitButton.setAttribute('aria-disabled', true);
            submitButton.disabled = true;
          });
          return;
        }
      }

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.dataset.content = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');

          if (productTemplate?.includes('pre-order')) {
            submitButtonText.dataset.content = window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.dataset.content = window.theme.variantStrings.addToCart;
          }
        }
      });

      if (!modifyClass) return;
    }

    /*
    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.dataset.content = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }
    */
   setUnavailable() {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      
      // --- START FIX ---
      let submitButtons = [];
      
      // 1. Get buttons from the form
      if (productForm) {
        submitButtons = Array.from(productForm.querySelectorAll('.single-add-to-cart-button'));
      }

      // 2. Get sticky button
      const stickyModal = document.querySelector('.product-add-to-cart-sticky-modal');
      if (stickyModal) {
        const stickyBtn = stickyModal.querySelector('.single-add-to-cart-button');
        if (stickyBtn) submitButtons.push(stickyBtn);
      }
      // --- END FIX ---

      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.dataset.content = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {

      if (this.isDisabledFeature != 'true') {
        return;
      }

      const variant_data = this.getVariantData();

      

      if (variant_data && this.currentVariant) {

        const selected_options = this.currentVariant.options.map((value, index) => {
          return {
            value,
            index: `option${index + 1}`
          };
        });
        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);


        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                } else {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        });

      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;

        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }

      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productWrapper.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);

      if (this.hideVariants) {
        // Product images
        this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });

        // Product thumbnails
        this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_thumbs.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });
      }

    }

    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }

    bindNotifyMeButton() {
      const notifyButton = this.productWrapper?.querySelector('.notify-me-button');
      if (!notifyButton) return;
    
      notifyButton.addEventListener("click", (event) => {
        event.preventDefault();
    
        const popupOverlay = document.getElementById("popupOverlay");
        const closeButton = document.getElementById("closePopupButton");
        const backInStockForm = document.getElementById("backInStockForm");
        const customerEmailInput = document.getElementById("customerEmail");
        const backInStockMessage = document.getElementById("backInStockMessage");
        const popupTitle = document.getElementById("backInStockProductName");
    
        popupOverlay.classList.remove("hidden");
    
        popupTitle.textContent = notifyButton.getAttribute("data-product-name");
    
        const closePopup = () => {
          popupOverlay.classList.add("hidden");
          backInStockMessage.classList.remove("success");
          backInStockMessage.classList.add("hidden");
          customerEmailInput.value = "";
        };
    
        closeButton.onclick = closePopup;
        popupOverlay.onclick = (e) => {
          if (e.target === popupOverlay) closePopup();
        };
    
        backInStockForm.onsubmit = function (e) {
          e.preventDefault();
          const email = customerEmailInput.value;
          const productId = notifyButton.getAttribute("data-variant-id");
    
          const payload = {
            data: {
              type: "back-in-stock-subscription",
              attributes: {
                profile: {
                  data: {
                    type: "profile",
                    attributes: { email }
                  }
                },
                channels: ["EMAIL"],
              },
              relationships: {
                variant: {
                  data: {
                    type: "catalog-variant",
                    id: `$shopify:::$default:::${productId}`
                  }
                }
              }
            }
          };
    
          fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=ME79pB", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "revision": "2024-06-15",
              "X-Klaviyo-Onsite": "1"
            },
            body: JSON.stringify(payload),
          })
            .then(() => {
              backInStockMessage.textContent = "You're in! We'll let you know when it's back";
              backInStockMessage.classList.add("success");
              backInStockMessage.classList.remove("hidden");
            })
            .catch(() => {
              backInStockMessage.textContent = "There was an error. Please try again.";
              backInStockMessage.classList.remove("hidden");
            });
        };
      });
    }

    toggleNotifyMeButton() {
      const notifyButton = this.productWrapper?.querySelector('.notify-me-button');
      if (!notifyButton) return;
    
      if (!this.currentVariant || !this.currentVariant.available) {
        notifyButton.style.display = 'flex';
        //notifyButton.setAttribute('data-product-name', this.dataset.productName || '');
        //notifyButton.setAttribute('data-variant-id', this.currentVariant?.id || '');
      } else {
        notifyButton.style.display = 'none';
      }
    }

  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
    super();
    this.addEventListener('change', this.setupProductGallery);

    // Debounce helper
    this._debounce = (fn, wait = 150) => {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    };
  }

  connectedCallback() {
    this.product_container = this.closest('.thb-product-detail');
    this.quickView = this.closest('#Product-Drawer-Content');
    this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
    this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');
    this.progress_bar = this.product_container.querySelector('.flickity-progress--bar');

    this.setOptions();

    // ✅ Ensure zoom is initialized even if Flickity slider is not
    this.setupProductGallery();

    // Start Slider
    this.init();

    // --- NEW: track current breakpoint state
    this._prevIsMobile = window.innerWidth <= 1067;

    // --- NEW: resize + breakpoint listeners
    this._onResize = this._debounce(() => this._handleResize());
    window.addEventListener('resize', this._onResize);

    this._mq = window.matchMedia('(max-width: 1067px)');
    this._onMqlChange = (e) => this._handleBreakpointChange(e.matches);
    if (this._mq.addEventListener) {
      this._mq.addEventListener('change', this._onMqlChange);
    } else if (this._mq.addListener) {
      // Safari < 14
      this._mq.addListener(this._onMqlChange);
    }
  }

  // --- NEW: cleanup listeners
  disconnectedCallback() {
    window.removeEventListener('resize', this._onResize);
    if (this._mq) {
      if (this._mq.removeEventListener) {
        this._mq.removeEventListener('change', this._onMqlChange);
      } else if (this._mq.removeListener) {
        this._mq.removeListener(this._onMqlChange);
      }
    }
  }

  setOptions() {
    this.hide_variants = this.dataset.hideVariants == 'true';
    this.thumbnails = this.thumbnail_container?.querySelectorAll('.product-thumbnail');
    this.prev_button = this.querySelector('.previous');
    this.next_button = this.querySelector('.next');
    this.images = this.querySelectorAll('img');

    const isMobile = window.innerWidth <= 1067;

    this.options = {
      wrapAround: false,
      pageDots: true,
      cellAlign: this.quickView || isMobile ? 'left' : 'right',
      adaptiveHeight: !this.quickView,
      initialIndex: '.is-initial-selected',
      prevNextButtons: true,
      groupCells: !this.quickView && isMobile ? false : true,
      fade: false,
      cellSelector: '.product-images__slide.is-active',
      freeScroll: false,
      contain: true,
      on: {
        ready: () => {
          this.images.forEach((img) => {
            img.addEventListener('lazyloaded', () => {
              this.flkty?.resize();
            });
          });
        },
        dragStart: () => {
          this.flkty.slider.childNodes.forEach(slide => slide.style.pointerEvents = "none");
        },
        dragEnd: () => {
          this.flkty.slider.childNodes.forEach(slide => slide.style.pointerEvents = "all");
        }
      }
    };

    if (this.quickView) {
      this.options.wrapAround = false;
    }
    if (this.progress_bar) {
      this.options.on.scroll = (progress) => {
        progress = Math.max(0, Math.min(1, progress));
        this.progress_bar.style.width = progress * 100 + '%';
      };
    }
  }

  init() {
    const isMobile = window.matchMedia('(max-width: 1067px)').matches;
    const enableDesktopSlider = this.dataset.desktopSlider === 'true';

    // Only start slider on mobile or if desktop slider is enabled
    if (!enableDesktopSlider && !isMobile) {
      return;
    }

    this.flkty = new Flickity(this, this.options);
    this.selectedIndex = this.flkty.selectedIndex;

    // Setup Events
    this.setupEvents();

    // Start Gallery
    this.setupProductGallery();
  }

  // --- UPDATED: safer reInit
  reInit() {
    try {
      this.flkty?.destroy();
    } catch (e) {
      // ignore if not initialized yet
    }
    this.flkty = null;

    const isMobile = window.matchMedia('(max-width: 1067px)').matches;
    const enableDesktopSlider = this.dataset.desktopSlider === 'true';

    // Only start slider on mobile or if desktop slider is enabled
    if (!isMobile && !enableDesktopSlider) {
      return;
    }

    this.setOptions();
    this.flkty = new Flickity(this, this.options);

    // Setup Events
    this.setupEvents();

    this.selectedIndex = this.flkty.selectedIndex;
  }

  // --- NEW: lightweight resize vs breakpoint re-init
  _handleResize() {
    // Always let Flickity recalc sizes if present
    this.flkty?.resize();

    const isMobile = window.innerWidth <= 1067;
    if (isMobile !== this._prevIsMobile) {
      // Breakpoint crossed -> reconfigure/create/destroy
      this._handleBreakpointChange(isMobile);
    }
  }

  // --- NEW: breakpoint crossing logic
  _handleBreakpointChange(isMobileNow) {
    const enableDesktopSlider = this.dataset.desktopSlider === 'true';
    const shouldEnable = isMobileNow || enableDesktopSlider;

    if (shouldEnable) {
      // If we should have a slider, (re)init it with new options
      if (this.flkty) {
        this.reInit();
      } else {
        this.setOptions();
        this.init();
      }
    } else {
      // Should not have a slider on desktop -> destroy if exists
      if (this.flkty) {
        try {
          this.flkty.destroy();
        } catch (e) {}
        this.flkty = null;
      }
    }
    this._prevIsMobile = isMobileNow;
  }
    setupEvents() {
      const _this = this;
      if (this.prev_button) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode.append(prev);
        this.prev_button.remove();
        prev.addEventListener('click', (event) => {
          this.flkty.previous();
        });
        prev.addEventListener('keyup', (event) => {
          this.flkty.previous();
          event.preventDefault();
        });
      }
      if (this.next_button) {
        let next = this.next_button.cloneNode(true);
        this.next_button.parentNode.append(next);
        this.next_button.remove();
        next.addEventListener('click', (event) => {
          this.flkty.next();
        });
        next.addEventListener('keyup', (event) => {
          this.flkty.next();
          event.preventDefault();
        });
      }
      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });
      this.flkty.on('settle', function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on('change', (index) => {

        let previous_slide = this.flkty.cells[_this.selectedIndex].element,
          previous_media = previous_slide.querySelector('.product-single__media');

        if (this.thumbnails) {
          let active_thumbs = Array.from(this.thumbnails).filter(element => element.classList.contains('is-active')),
            active_thumb = active_thumbs[index] ? active_thumbs[index] : active_thumbs[0];

          this.thumbnails.forEach((item, i) => {
            item.classList.remove('is-initial-selected');
          });
          active_thumb.classList.add('is-initial-selected');

          requestAnimationFrame(() => {
            if (active_thumb.offsetParent === null) {
              return;
            }
            const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
              windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
            active_thumb.parentElement.scrollTo({
              left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
              top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
              behavior: 'smooth'
            });
          });
        }


        // Stop previous video
        if (previous_media.classList.contains('product-single__media-external-video')) {
          if (previous_media.dataset.provider === 'youtube') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              event: "command",
              func: "pauseVideo",
              args: ""
            }), "*");
          } else if (previous_media.dataset.provider === 'vimeo') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              method: "pause"
            }), "*");
          }
          previous_media.querySelector('.product-single__media-external-video--play').removeAttribute('hidden');
        } else if (previous_media.classList.contains('product-single__media-native-video')) {
          previous_media.querySelector('video').pause();
        }

      });

      /* Start The Custom Arrows Remove when last */
      this.flkty.on( 'select', function( index ) {
        let flkty = this;

        var flktySlider = flkty.element,
            slides = flktySlider.querySelectorAll('.carousel__slide');
        
        var viewport = flktySlider.querySelector('.flickity-viewport'),
            viewportBounds = viewport.getBoundingClientRect(),
            viewportBoundsLeft = viewportBounds.left,
            viewportBoundsRight = viewportBounds.right,
            visibleSlides = -1,
            prev_buttons = flktySlider.querySelectorAll('.flickity-prev'),
            next_buttons = flktySlider.querySelectorAll('.flickity-next');
        
        slides.forEach(function(slide) {
            var slideWidth = slide.offsetWidth,
                slideBounds = slide.getBoundingClientRect(),
                slideBoundsLeft = slideBounds.left;
        
            var insideViewportLeft = (slideBoundsLeft + slideWidth > viewportBoundsLeft),
                insideViewportRight = (slideBoundsLeft < viewportBoundsRight);

            if(insideViewportLeft && insideViewportRight){
              visibleSlides++;
            }
        });

        if(visibleSlides <= 0){
          visibleSlides = 1;
        }
        
        if (!flkty.slides[flkty.selectedIndex - 1]) {
          prev_buttons.forEach(function (prev_button) {
            prev_button.setAttribute("disabled", "disabled");
            prev_button.style.display = 'none';
          });
          next_buttons.forEach(function (next_button) {
            next_button.removeAttribute("disabled");
            next_button.style.display = 'flex';
          });
        } else if (!flkty.slides[flkty.selectedIndex + visibleSlides]) {
          next_buttons.forEach(function (next_button) {
            next_button.setAttribute("disabled", "disabled");
            next_button.style.display = 'none';
          });
          prev_buttons.forEach(function (prev_button) {
            prev_button.removeAttribute("disabled");
            prev_button.style.display = 'flex';
          });
        } else {
          prev_buttons.forEach(function (prev_button) {
            prev_button.removeAttribute("disabled");
            prev_button.style.display = 'flex';
          });
          next_buttons.forEach(function (next_button) {
            next_button.removeAttribute("disabled");
            next_button.style.display = 'flex';
          });
        }
      });

      this.flkty.on( 'dragEnd', function( event, pointer ) {
        let flkty = this;

        var flktySlider = flkty.element,
            slides = flktySlider.querySelectorAll('.carousel__slide');
        
        var viewport = flktySlider.querySelector('.flickity-viewport'),
            viewportBounds = viewport.getBoundingClientRect(),
            viewportBoundsLeft = viewportBounds.left,
            viewportBoundsRight = viewportBounds.right,
            visibleSlides = 0,
            prev_buttons = flktySlider.querySelectorAll('.flickity-prev'),
            next_buttons = flktySlider.querySelectorAll('.flickity-next');
        
        setTimeout(function () {
            slides.forEach(function(slide) {
                var slideWidth = slide.offsetWidth,
                    slideBounds = slide.getBoundingClientRect(),
                    slideBoundsLeft = slideBounds.left;
            
                var insideViewportLeft = (slideBoundsLeft + slideWidth > viewportBoundsLeft),
                    insideViewportRight = (slideBoundsLeft < viewportBoundsRight);

                if(insideViewportLeft && insideViewportRight){
                  visibleSlides++;
                }
            });

            if(visibleSlides <= 0){
              visibleSlides = 1;
            }
            
            if (!flkty.slides[flkty.selectedIndex - 1]) {
              prev_buttons.forEach(function (prev_button) {
                prev_button.setAttribute("disabled", "disabled");
                prev_button.style.display = 'none';
              });
              next_buttons.forEach(function (next_button) {
                next_button.removeAttribute("disabled");
                next_button.style.display = 'flex';
              });
            } else if (!flkty.slides[flkty.selectedIndex + visibleSlides]) {
              next_buttons.forEach(function (next_button) {
                next_button.setAttribute("disabled", "disabled");
                next_button.style.display = 'none';
              });
              prev_buttons.forEach(function (prev_button) {
                prev_button.removeAttribute("disabled");
                prev_button.style.display = 'flex';
              });
            } else {
              prev_buttons.forEach(function (prev_button) {
                prev_button.removeAttribute("disabled");
                prev_button.style.display = 'flex';
              });
              next_buttons.forEach(function (next_button) {
                next_button.removeAttribute("disabled");
                next_button.style.display = 'flex';
              });
            }
            console.log(visibleSlides);
            console.log('drag ends');
          
        }, 1000);

      });

    /* End The Custom Arrows Remove when last */

      if (this.thumbnails && !this.thumbnail_container.dataset.init) {
        setTimeout(() => {
          let active_thumbs = Array.from(this.thumbnails).filter(element => element.clientWidth > 0);
          active_thumbs.forEach((thumbnail, index) => {
            thumbnail.addEventListener('click', () => {
              this.thumbnailClick(thumbnail, index);
            });
          });
          this.thumbnail_container.addEventListener('click', (e) => {
            let count = Math.min(Math.max(this.thumbnail_container.querySelectorAll('.is-active').length, 1), 4);
            this.thumbnail_container.style.setProperty('--thumbnail-width', (count * 63) + 19 + 'px');
            if (!this.thumbnail_container.classList.contains('extended')) {
              this.thumbnail_container.classList.add('extended');
            } else {
              if (e.target.nodeName == 'BUTTON') {
                this.thumbnail_container.classList.remove('extended');
              }
              e.preventDefault();
            }
            if (!this.thumbnail_container.classList.contains('extended')) {
              let active_thumb = this.thumbnail_container.querySelector('.is-initial-selected');
              setTimeout(() => {
                active_thumb.parentElement.scrollTo({
                  left: Math.max(active_thumb.offsetLeft, 0),
                  top: 0,
                  behavior: 'smooth'
                });
              }, 300);
            }
          });
          this.thumbnail_container.dataset.init = true;
        });
      }
    }
    thumbnailClick(thumbnail, index) {
      [].forEach.call(this.thumbnails, function (el) {
        el.classList.remove('is-initial-selected');
      });
      thumbnail.classList.add('is-initial-selected');
      this.flkty.select(index);
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));

      return this.activeImages.map((item) => {
        let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);

        let activelink = item.querySelector('.product-single__media-zoom');

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h
        };
      });
    }
    
    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];
      
      this.pswpOptions = {
        maxSpreadZoom: 2,
        arrowPrevSVG: window.PhotoSwipeArrowPrev,
        arrowNextSVG: window.PhotoSwipeArrowNext,
        closeSVG: window.PhotoSwipeClose,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        maxZoomLevel: 2,
        bgOpacity: 1,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-selected');
          const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          const rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };
  
      this.links.forEach((link => {
        link.addEventListener('click', (e) => this.zoomClick(e, link));
      }));
    }
    
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        this.pswpOptions['dataSource'] = this.items;
        if (!window.matchMedia('(max-width: 768px)').matches) {
          this.pswpOptions['secondaryZoomLevel'] = 2;
        }
        this.pswpOptions['initialZoomLevel'] = 'fill';
        this.pswpOptions['allowPanToNext'] = true;
        const pswp = new PhotoSwipe(this.pswpOptions);
        const toTop = () => {
          if (!window.matchMedia('(max-width: 768px)').matches) {
            pswp.currSlide.panTo(0, 0);
            const els = document.querySelectorAll('.pswp__zoom-wrap')
            els.forEach((el) => {
              const transformParts = el.style.transform.split(',')
              transformParts[1] = ' 0px'
              el.style.transform = transformParts.join(',')
            })
          }
        }
        pswp.on('change', function () {
          toTop()
        })
        pswp.on('openingAnimationEnd', function () {
          toTop()
        })
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.sticky = this.dataset.sticky;
      // this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form = this.querySelector('form') || document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name=id]').disabled = false;
      // if (!this.sticky) {
      //   this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      // }
      if (!this.sticky) {
        if (!this.form.dataset.submitListenerAttached) {
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
          this.form.dataset.submitListenerAttached = '1';
        }
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      // if (this.form.dataset.submitting === '1') return;
      // this.form.dataset.submitting = '1';

      const sizeWrapperElement = document.querySelector(`.${this.dataset.formId}-fielset-size`);
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button'); 
      
      if(sizeWrapperElement){
        const sizeMessage = document.querySelector(`.${this.dataset.formId}-size-message`);
        const sizeLabel = document.querySelector(`.form__label--${this.dataset.formId}-size`);
        if (!sizeWrapperElement.classList.contains('product-form__input-size')) {
          sizeWrapperElement.classList.remove('product-form__input-size-validation-fail');
          submitButtons.forEach((submitButton) => {
            if (submitButton.classList.contains('loading')) return;
            submitButton.removeAttribute('aria-disabled');
            submitButton.disabled = false;
          });
        } else {
          sizeWrapperElement.classList.add('product-form__input-size-validation-fail');
          submitButtons.forEach((submitButton) => {
            if (submitButton.classList.contains('loading')) return;
            submitButton.setAttribute('aria-disabled', true);
            submitButton.disabled = true;
          });


          const submitter = evt.submitter;
          const isStickyButton = submitter && submitter.id === 'AddToCartSticky';
          if (isStickyButton) {
            const sizeSelector = document.querySelector('.variations');
            if (sizeSelector) {
              sizeSelector.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
          }

          return;
        }
      }

      if (!this.form.reportValidity()) {
        return;
      }

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };


      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
          // if (document.querySelector('.product-add-to-cart-sticky-modal')) {
          //   document.querySelector('.product-add-to-cart-sticky-modal').removeAttribute('open');
          // } 
          // this.form.dataset.submitting = '0';
        });
    
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
        if (section.id == 'Cart-Drawer') {
          elementToReplace.removeProductEvent();
          elementToReplace.notesToggle();
          elementToReplace.termsCheckbox();
          elementToReplace.updateFreeShipping();
        }
      }));



      let product_drawer = document.getElementById('Product-Drawer'),
        search_drawer = document.getElementById('Search-Drawer');

      if (search_drawer.classList.contains('active')) {
        search_drawer.classList.remove('active');
      }
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.classList.remove('active');
        this.body.classList.remove('open-cc--product');
        if (document.getElementById('Cart-Drawer')) {
          this.body.classList.add('open-cc');
          document.getElementById('Cart-Drawer').classList.add('active');
        }
      } else if (document.getElementById('Cart-Drawer')) {
        this.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.setupObservers();
      this.drawer = document.getElementById(this.dataset.target);
      this.addEventListener('click', this.onClick.bind(this));
    }
    onClick() {
      this.drawer.show();
    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
              }
            }
            if (entry.target === form) {
              let boundingRect = form.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 1]
        }),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer');
      _this.formPassed = false;
      observer.observe(form);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

if (typeof addIdToRecentlyViewed !== undefined) {
  addIdToRecentlyViewed();
}



/* PDP STICKY ATC - new function */
document.addEventListener('DOMContentLoaded', () => {
  const addToCartBtn = document.querySelector('#AddToCart');
  const stickyModal = document.querySelector('.product-add-to-cart-sticky-modal');
  const footer = document.querySelector('footer');

  if (!addToCartBtn || !stickyModal || !footer) return;


  let addToCartOffset = addToCartBtn.getBoundingClientRect().top + window.scrollY;

  const toggleSticky = (isVisible) => {
    const scrollY = window.scrollY || window.pageYOffset;
    const windowHeight = window.innerHeight;

    const footerTop = footer.getBoundingClientRect().top + scrollY;
    const footerHeight = footer.offsetHeight;
    const footerBottom = footerTop + footerHeight;
    const btnRewards = document.querySelector('.c-launchBubble');
    const backToTop = document.querySelector('.back-to-top.back-to-top--active');

    if (!stickyModal.parentElement.isSameNode(document.body)) {
      document.body.appendChild(stickyModal);
    }
    stickyModal.style.position = 'fixed';
    stickyModal.style.bottom = '0';
    stickyModal.style.width = '100%';


    // Add padding footer
    if (scrollY + windowHeight >= footerTop) {
      footer.style.paddingBottom = `${stickyModal.offsetHeight + 20}px`;
    } else {
      footer.style.paddingBottom = '';
    }

    if (!isVisible && scrollY > addToCartOffset) {
      stickyModal.classList.add('open-sticky-modal');
      if (btnRewards) {
        btnRewards.classList.add('atc-sticky-active');
      }
      if (backToTop) {
        backToTop.classList.add('atc-sticky-active');
      }
    } else {
      stickyModal.classList.remove('open-sticky-modal');
      if (btnRewards) {
        btnRewards.classList.remove('atc-sticky-active');
      }
      if (backToTop) {
        backToTop.classList.remove('atc-sticky-active');
      }
    }
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        toggleSticky(entry.isIntersecting);
      });
    },
    { threshold: 0 }
  );

  observer.observe(addToCartBtn);

  window.addEventListener('scroll', () => {
    const rect = addToCartBtn.getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
    toggleSticky(isVisible);
  });

  window.addEventListener('resize', () => {
    addToCartOffset = addToCartBtn.getBoundingClientRect().top + window.scrollY;
  });
});













